import { Autocomplete, TextField } from "@mui/material";
import { useQuery } from "react-query";
import API from "../../../services/API";

export default function PackCourses({ id, value, onChange }){

    const { data, isSuccess } = useQuery({

        queryKey: 'pack-courses',

        queryFn: () => API.get(`/products?type=course`)
            .then(r => r.data
                .filter(p => p.variant?.id === 'standard')
            )
    });

    const handleChange = (_, newValue) => {

        const oldValue = value ? [...value] : [];

        onChange(newValue);
        
        API.put(`/products/${id}/links`, newValue)
            .then(r => console.log(r.status, r.data))
            .catch(_ => onChange(oldValue))
    }

    return isSuccess &&

        <Autocomplete
            multiple
            id={`product-${id}-children`}
            options={data}
            value={value}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={option => option.title}
            onChange={handleChange}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Formations du pack"
                    size="small"
                />
            )}
        />
    
}
